<!-- =========================================================================================
  File Name: VerticalSidebar.vue
  Description: Sidebar Component
  Component Name: VerticalSidebar
========================================================================================== -->

<template>
  <section class="lg:relative absolute grid justify-center items-start place-content-center">
    <div
      class="py-6 flex flex-col justify-start fixed bg-white shadow-sm rounded-lg gap-6 w-24 place-content-center justify-self-center"
      style="height: 93%">
      <router-link class="flex relative items-center w-full justify-center cursor-pointer" to="/user/dashboard">
        <img class="w-auto h-12 object-cover" src="@/assets/images/new-sidebar/icon.svg" />
      </router-link>
      <span class="w-auto bg-slate-100 mx-4 rounded-full xl:my-0 my-0" style="padding: 0.5px 0px"></span>

      <div class="flex relative items-center w-full justify-center flex-col xl:gap-6 gap-4">
        <vx-tooltip text="Dashboard" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.id + '/dashboard'"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item"
            :class="activeRoute === 'org-home' ? 'sidebar__item__active' : ''">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                <path
                  d="M21.743 12.331L12.743 2.331C12.364 1.909 11.636 1.909 11.257 2.331L2.25698 12.331C2.12767 12.4747 2.04277 12.6527 2.01255 12.8436C1.98232 13.0345 2.00807 13.2301 2.08668 13.4067C2.16529 13.5833 2.29339 13.7333 2.45548 13.8386C2.61757 13.9439 2.8067 13.9999 2.99998 14H4.99998V21C4.99998 21.2652 5.10534 21.5196 5.29288 21.7071C5.48041 21.8946 5.73477 22 5.99998 22H18C18.2652 22 18.5196 21.8946 18.7071 21.7071C18.8946 21.5196 19 21.2652 19 21V14H21C21.1936 14.0008 21.3834 13.9453 21.546 13.8401C21.7087 13.735 21.8372 13.5848 21.916 13.4079C21.9947 13.231 22.0203 13.0349 21.9896 12.8437C21.9589 12.6525 21.8732 12.4744 21.743 12.331ZM12 16C11.2043 16 10.4413 15.6839 9.87866 15.1213C9.31605 14.5587 8.99998 13.7956 8.99998 13C8.99998 12.2043 9.31605 11.4413 9.87866 10.8787C10.4413 10.3161 11.2043 10 12 10C12.7956 10 13.5587 10.3161 14.1213 10.8787C14.6839 11.4413 15 12.2043 15 13C15 13.7956 14.6839 14.5587 14.1213 15.1213C13.5587 15.6839 12.7956 16 12 16Z"
                  fill="#FBB603" />
                <rect x="5" y="10" width="14" height="7" fill="#FBB603" />
                <circle cx="12" cy="17" r="3" fill="#737171" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M21.7427 12.3311L12.7427 2.33115C12.3637 1.90915 11.6357 1.90915 11.2567 2.33115L2.25674 12.3311C2.12743 12.4748 2.04253 12.6529 2.0123 12.8438C1.98208 13.0347 2.00783 13.2303 2.08644 13.4068C2.16505 13.5834 2.29315 13.7334 2.45523 13.8387C2.61732 13.944 2.80645 14.0001 2.99974 14.0001H4.99974V21.0001C4.99974 21.2654 5.1051 21.5197 5.29263 21.7073C5.48017 21.8948 5.73452 22.0001 5.99974 22.0001H17.9997C18.265 22.0001 18.5193 21.8948 18.7068 21.7073C18.8944 21.5197 18.9997 21.2654 18.9997 21.0001V14.0001H20.9997C21.1934 14.001 21.3831 13.9454 21.5458 13.8403C21.7084 13.7352 21.837 13.585 21.9157 13.408C21.9945 13.2311 22.0201 13.0351 21.9894 12.8439C21.9586 12.6527 21.873 12.4745 21.7427 12.3311ZM11.9997 16.0001C11.2041 16.0001 10.441 15.6841 9.87842 15.1215C9.31581 14.5589 8.99974 13.7958 8.99974 13.0001C8.99974 12.2045 9.31581 11.4414 9.87842 10.8788C10.441 10.3162 11.2041 10.0001 11.9997 10.0001C12.7954 10.0001 13.5584 10.3162 14.1211 10.8788C14.6837 11.4414 14.9997 12.2045 14.9997 13.0001C14.9997 13.7958 14.6837 14.5589 14.1211 15.1215C13.5584 15.6841 12.7954 16.0001 11.9997 16.0001Z"
                  fill="#737171" />
                <rect x="5" y="10" width="14" height="7" fill="#737171" />
                <circle cx="12" cy="17" r="3" fill="#FBB603" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip text="Boards" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.slug + '/boards'" :class="activeRoute === 'org-boards'
              ? 'sidebar__item__active'
              : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                <rect x="3" y="3" width="8" height="8" rx="2" fill="#F2C244" />
                <rect x="3" y="13" width="8" height="8" rx="2" fill="#F2C244" />
                <rect x="13" y="3" width="8" height="8" rx="2" fill="#737171" />
                <rect x="13" y="13" width="8" height="8" rx="2" fill="#F2C244" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="8" height="8" rx="2" fill="#737171" />
                <rect x="3" y="13" width="8" height="8" rx="2" fill="#737171" />
                <rect x="13" y="3" width="8" height="8" rx="2" fill="#FBB603" />
                <rect x="13" y="13" width="8" height="8" rx="2" fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <!-- route for board template  -->
        <!-- 
        <vx-tooltip
          text="Board Templates"
          position="right"
          class="flex flex-col w-full"
        >
          <router-link
            :to="'/organization/' + orgData.slug + '/board-templates'"
            :class="
              activeRoute === 'org-board-templates'
                ? 'sidebar__item__active'
                : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item"
          >
            <span
              class="absolute w-full h-full bg-primary rounded __hover"
              style="right: 95%"
            ></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="absolute __hover"
              >
                <rect x="3" y="3" width="8" height="8" rx="2" fill="#F2C244" />
                <rect x="3" y="13" width="8" height="8" rx="2" fill="#F2C244" />
                <rect x="13" y="3" width="8" height="8" rx="2" fill="#737171" />
                <rect
                  x="13"
                  y="13"
                  width="8"
                  height="8"
                  rx="2"
                  fill="#F2C244"
                />
              </svg>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <rect x="3" y="3" width="8" height="8" rx="2" fill="#737171" />
                <rect x="3" y="13" width="8" height="8" rx="2" fill="#737171" />
                <rect x="13" y="3" width="8" height="8" rx="2" fill="#FBB603" />
                <rect
                  x="13"
                  y="13"
                  width="8"
                  height="8"
                  rx="2"
                  fill="#737171"
                />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle"
                >Dashboard</span
              >
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip> -->

        <vx-tooltip text="Notifications" position="right" class="hidden flex-col w-full">
          <router-link to="/user/notifications" :class="activeRoute === 'notifications' ? 'sidebar__item__active' : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path
                  d="M12 22C12.6193 22.0008 13.2235 21.8086 13.7285 21.4502C14.2335 21.0917 14.6143 20.5849 14.818 20H9.182C9.38566 20.5849 9.76648 21.0917 10.2715 21.4502C10.7765 21.8086 11.3807 22.0008 12 22ZM19 14.586V10C19 6.783 16.815 4.073 13.855 3.258C13.562 2.52 12.846 2 12 2C11.154 2 10.438 2.52 10.145 3.258C7.185 4.074 5 6.783 5 10V14.586L3.293 16.293C3.19996 16.3857 3.12617 16.4959 3.07589 16.6172C3.0256 16.7386 2.99981 16.8687 3 17V18C3 18.2652 3.10536 18.5196 3.29289 18.7071C3.48043 18.8946 3.73478 19 4 19H20C20.2652 19 20.5196 18.8946 20.7071 18.7071C20.8946 18.5196 21 18.2652 21 18V17C21.0002 16.8687 20.9744 16.7386 20.9241 16.6172C20.8738 16.4959 20.8 16.3857 20.707 16.293L19 14.586Z"
                  fill="#F2C244" />
                <path
                  d="M12 22C12.6193 22.0008 13.2235 21.8086 13.7285 21.4502C14.2335 21.0917 14.6143 20.5849 14.818 20H9.182C9.38566 20.5849 9.76648 21.0917 10.2715 21.4502C10.7765 21.8086 11.3807 22.0008 12 22Z"
                  fill="#F2C244" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 22C12.6193 22.0008 13.2235 21.8086 13.7285 21.4502C14.2335 21.0917 14.6143 20.5849 14.818 20H9.182C9.38566 20.5849 9.76648 21.0917 10.2715 21.4502C10.7765 21.8086 11.3807 22.0008 12 22ZM19 14.586V10C19 6.783 16.815 4.073 13.855 3.258C13.562 2.52 12.846 2 12 2C11.154 2 10.438 2.52 10.145 3.258C7.185 4.074 5 6.783 5 10V14.586L3.293 16.293C3.19996 16.3857 3.12617 16.4959 3.07589 16.6172C3.0256 16.7386 2.99981 16.8687 3 17V18C3 18.2652 3.10536 18.5196 3.29289 18.7071C3.48043 18.8946 3.73478 19 4 19H20C20.2652 19 20.5196 18.8946 20.7071 18.7071C20.8946 18.5196 21 18.2652 21 18V17C21.0002 16.8687 20.9744 16.7386 20.9241 16.6172C20.8738 16.4959 20.8 16.3857 20.707 16.293L19 14.586Z"
                  fill="#737171" />
                <path
                  d="M11.9977 22C12.617 22.0008 13.2211 21.8086 13.7262 21.4502C14.2312 21.0917 14.612 20.5849 14.8157 20H9.17969C9.38335 20.5849 9.76416 21.0917 10.2692 21.4502C10.7742 21.8086 11.3784 22.0008 11.9977 22Z"
                  fill="#FBB603" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip text="Community" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.slug + '/users'"
            :class="activeRoute === 'org-users' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                <path d="M13.7656 6.11523L17.8845 10.2341" stroke="#FBB603" stroke-width="2" stroke-linecap="round" />
                <path d="M6.11719 13.7656L10.2361 17.8845" stroke="#FBB603" stroke-width="2" stroke-linecap="round" />
                <path d="M10.2361 6.11523L6.11719 10.2341" stroke="#FBB603" stroke-width="2" stroke-linecap="round" />
                <path d="M17.8845 13.7656L13.7656 17.8845" stroke="#FBB603" stroke-width="2" stroke-linecap="round" />
                <path
                  d="M12.0021 6.7044C13.302 6.7044 14.3558 5.65063 14.3558 4.35073C14.3558 3.05084 13.302 1.99707 12.0021 1.99707C10.7022 1.99707 9.64844 3.05084 9.64844 4.35073C9.64844 5.65063 10.7022 6.7044 12.0021 6.7044Z"
                  stroke="#FBB603" stroke-width="2" />
                <path
                  d="M12.0021 22.0032C13.302 22.0032 14.3558 20.9495 14.3558 19.6496C14.3558 18.3497 13.302 17.2959 12.0021 17.2959C10.7022 17.2959 9.64844 18.3497 9.64844 19.6496C9.64844 20.9495 10.7022 22.0032 12.0021 22.0032Z"
                  stroke="#FBB603" stroke-width="2" />
                <path
                  d="M4.35366 14.3538C5.65356 14.3538 6.70733 13.3 6.70733 12.0001C6.70733 10.7003 5.65356 9.64648 4.35366 9.64648C3.05377 9.64648 2 10.7003 2 12.0001C2 13.3 3.05377 14.3538 4.35366 14.3538Z"
                  stroke="#FBB603" stroke-width="2" />
                <path
                  d="M19.6427 14.3538C20.9426 14.3538 21.9964 13.3 21.9964 12.0001C21.9964 10.7003 20.9426 9.64648 19.6427 9.64648C18.3428 9.64648 17.2891 10.7003 17.2891 12.0001C17.2891 13.3 18.3428 14.3538 19.6427 14.3538Z"
                  stroke="#FBB603" stroke-width="2" />
                <path
                  d="M4.34605 13.0876C4.94706 13.0876 5.43428 12.6004 5.43428 11.9994C5.43428 11.3984 4.94706 10.9111 4.34605 10.9111C3.74503 10.9111 3.25781 11.3984 3.25781 11.9994C3.25781 12.6004 3.74503 13.0876 4.34605 13.0876Z"
                  fill="#737171" stroke="#737171" />
                <path
                  d="M12.0023 20.737C12.6033 20.737 13.0905 20.2498 13.0905 19.6488C13.0905 19.0478 12.6033 18.5605 12.0023 18.5605C11.4013 18.5605 10.9141 19.0478 10.9141 19.6488C10.9141 20.2498 11.4013 20.737 12.0023 20.737Z"
                  fill="#737171" stroke="#737171" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M13.7656 6.11523L17.8845 10.2341" stroke="#737171" stroke-width="2" stroke-linecap="round" />
                <path d="M6.11719 13.7656L10.2361 17.8845" stroke="#737171" stroke-width="2" stroke-linecap="round" />
                <path d="M10.2361 6.11523L6.11719 10.2341" stroke="#737171" stroke-width="2" stroke-linecap="round" />
                <path d="M17.8845 13.7656L13.7656 17.8845" stroke="#737171" stroke-width="2" stroke-linecap="round" />
                <path
                  d="M12.0021 6.7044C13.302 6.7044 14.3558 5.65063 14.3558 4.35073C14.3558 3.05084 13.302 1.99707 12.0021 1.99707C10.7022 1.99707 9.64844 3.05084 9.64844 4.35073C9.64844 5.65063 10.7022 6.7044 12.0021 6.7044Z"
                  stroke="#737171" stroke-width="2" />
                <path
                  d="M12.0021 22.0032C13.302 22.0032 14.3558 20.9495 14.3558 19.6496C14.3558 18.3497 13.302 17.2959 12.0021 17.2959C10.7022 17.2959 9.64844 18.3497 9.64844 19.6496C9.64844 20.9495 10.7022 22.0032 12.0021 22.0032Z"
                  stroke="#737171" stroke-width="2" />
                <path
                  d="M4.35366 14.3538C5.65356 14.3538 6.70733 13.3 6.70733 12.0001C6.70733 10.7003 5.65356 9.64648 4.35366 9.64648C3.05377 9.64648 2 10.7003 2 12.0001C2 13.3 3.05377 14.3538 4.35366 14.3538Z"
                  stroke="#737171" stroke-width="2" />
                <path
                  d="M19.6427 14.3538C20.9426 14.3538 21.9964 13.3 21.9964 12.0001C21.9964 10.7003 20.9426 9.64648 19.6427 9.64648C18.3428 9.64648 17.2891 10.7003 17.2891 12.0001C17.2891 13.3 18.3428 14.3538 19.6427 14.3538Z"
                  stroke="#737171" stroke-width="2" />
                <path
                  d="M4.34605 13.0876C4.94706 13.0876 5.43428 12.6004 5.43428 11.9994C5.43428 11.3984 4.94706 10.9111 4.34605 10.9111C3.74503 10.9111 3.25781 11.3984 3.25781 11.9994C3.25781 12.6004 3.74503 13.0876 4.34605 13.0876Z"
                  fill="#FBB603" stroke="#FBB603" />
                <path
                  d="M12.0023 20.737C12.6033 20.737 13.0905 20.2498 13.0905 19.6488C13.0905 19.0478 12.6033 18.5605 12.0023 18.5605C11.4013 18.5605 10.9141 19.0478 10.9141 19.6488C10.9141 20.2498 11.4013 20.737 12.0023 20.737Z"
                  fill="#FBB603" stroke="#FBB603" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip text="Reviews" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.slug + '/reviews'" :class="activeRoute === 'org-reviews' ? 'sidebar__item__active' : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path
                  d="M8 12.0518C9.995 12.0518 11.5 10.5468 11.5 8.55176C11.5 6.55676 9.995 5.05176 8 5.05176C6.005 5.05176 4.5 6.55676 4.5 8.55176C4.5 10.5468 6.005 12.0518 8 12.0518ZM9 12.9998H7C4.243 12.9998 2 15.2428 2 17.9998V18.9998H14V17.9998C14 15.2428 11.757 12.9998 9 12.9998ZM20.294 8.29176L15.994 12.5838L14.702 11.2918L13.288 12.7058L15.994 15.4098L21.706 9.70776L20.294 8.29176Z"
                  fill="#F2C046" />
                <path
                  d="M20.294 8.29199L15.994 12.584L14.702 11.292L13.288 12.706L15.994 15.41L21.706 9.70799L20.294 8.29199Z"
                  fill="#737171" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M8 12.0518C9.995 12.0518 11.5 10.5468 11.5 8.55176C11.5 6.55676 9.995 5.05176 8 5.05176C6.005 5.05176 4.5 6.55676 4.5 8.55176C4.5 10.5468 6.005 12.0518 8 12.0518ZM9 12.9998H7C4.243 12.9998 2 15.2428 2 17.9998V18.9998H14V17.9998C14 15.2428 11.757 12.9998 9 12.9998ZM20.294 8.29176L15.994 12.5838L14.702 11.2918L13.288 12.7058L15.994 15.4098L21.706 9.70776L20.294 8.29176Z"
                  fill="#737171" />
                <path
                  d="M20.2951 8.29199L15.9951 12.584L14.7031 11.292L13.2891 12.706L15.9951 15.41L21.7071 9.70799L20.2951 8.29199Z"
                  fill="#FBB603" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>


        <vx-tooltip text="Treasury" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.slug + '/treasury'" :class="activeRoute === 'org-treasury' ? 'sidebar__item__active' : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path d="M14 9H22V15H14V9Z" fill="#737171" />
                <path
                  d="M20 3H5C3.346 3 2 4.346 2 6V18C2 19.654 3.346 21 5 21H20C21.103 21 22 20.103 22 19V17H14C12.897 17 12 16.103 12 15V9C12 7.897 12.897 7 14 7H22V5C22 3.897 21.103 3 20 3Z"
                  fill="#F2C046" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M14 9H22V15H14V9Z" fill="#FBB603" />
                <path
                  d="M20 3H5C3.346 3 2 4.346 2 6V18C2 19.654 3.346 21 5 21H20C21.103 21 22 20.103 22 19V17H14C12.897 17 12 16.103 12 15V9C12 7.897 12.897 7 14 7H22V5C22 3.897 21.103 3 20 3Z"
                  fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <!-- <vx-tooltip text="Apps" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.slug + '/marketplace'" :class="activeRoute === 'org-marketplace' ? 'sidebar__item__active' : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path
                  d="M18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 7.65685 16.3431 9 18 9Z"
                  fill="#737171" />
                <path
                  d="M13 6C13 5.288 13.153 4.613 13.422 4H6C4.897 4 4 4.897 4 6V18C4 19.103 4.897 20 6 20H18C19.103 20 20 19.103 20 18V10.578C19.3698 10.8559 18.6887 10.9997 18 11C16.6739 11 15.4021 10.4732 14.4645 9.53553C13.5268 8.59785 13 7.32608 13 6Z"
                  fill="#F2C046" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 7.65685 16.3431 9 18 9Z"
                  fill="#FBB603" />
                <path
                  d="M13 6C13 5.288 13.153 4.613 13.422 4H6C4.897 4 4 4.897 4 6V18C4 19.103 4.897 20 6 20H18C19.103 20 20 19.103 20 18V10.578C19.3698 10.8559 18.6887 10.9997 18 11C16.6739 11 15.4021 10.4732 14.4645 9.53553C13.5268 8.59785 13 7.32608 13 6Z"
                  fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip> -->

        <vx-tooltip text="Admins" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.slug + '/admins'"
            :class="activeRoute === 'org-admins' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path
                  d="M12.7187 6.56217C12.6943 6.10613 12.2282 6.18371 11.7734 6.18371C12.1094 6.27318 12.4272 6.39766 12.7187 6.56217Z"
                  fill="#F2C046" />
                <path
                  d="M7.8624 5.41895C6.09699 5.41895 5.28439 7.6535 6.69568 8.77737C7.17678 7.49273 8.13452 6.57032 9.39007 6.20624C9.04661 5.73142 8.49171 5.41895 7.8624 5.41895Z"
                  fill="#737171" />
                <path
                  d="M4.20959 8.4282C4.28154 8.65906 4.37475 8.88054 4.48549 9.09037L3.90557 9.67062C3.74984 9.82635 3.74984 10.0791 3.90557 10.2352L4.92776 11.2577C5.00221 11.3321 5.1042 11.374 5.21051 11.374C5.31565 11.374 5.41696 11.3321 5.4927 11.2577L6.07197 10.6775C6.1589 10.7235 6.25526 10.7517 6.34529 10.7913C6.34529 10.7847 6.34465 10.7779 6.34465 10.7713C6.34465 10.2971 6.39911 9.8498 6.49607 9.42976C5.79667 8.97964 5.32999 8.1983 5.32999 7.30622C5.32999 5.91274 6.46352 4.77889 7.85668 4.77889C8.80004 4.77889 9.61453 5.30406 10.0493 6.07134C10.5135 6.01377 10.9495 6.01377 11.4744 6.11295C11.4069 5.90871 11.3274 5.70883 11.2279 5.52147L11.8078 4.94095C11.8835 4.86618 11.9254 4.76451 11.9254 4.6588C11.9254 4.55306 11.8835 4.45142 11.8078 4.37666L10.7862 3.35479C10.7081 3.2766 10.6061 3.23781 10.5041 3.23781C10.4021 3.23781 10.3002 3.2766 10.2226 3.35479L9.64079 3.93531C9.43063 3.82397 9.2098 3.73076 8.97837 3.66038V2.84021C8.97837 2.62002 8.80068 2.44141 8.57985 2.44141H7.13416C6.91458 2.44141 6.73499 2.62002 6.73499 2.84021V3.66034C6.50417 3.73072 6.2833 3.82393 6.07249 3.93527L5.4927 3.3554C5.41447 3.27721 5.31251 3.23841 5.21051 3.23841C5.10855 3.23841 5.00599 3.27721 4.92841 3.35507L3.90557 4.37694C3.83113 4.45203 3.78923 4.55334 3.78923 4.65941C3.78923 4.76543 3.83113 4.86679 3.90557 4.94155L4.48549 5.52175C4.37471 5.73195 4.28154 5.95311 4.21088 6.18393H3.39136C3.17052 6.18393 2.99219 6.36283 2.99219 6.58334V8.02907C2.99219 8.24894 3.17052 8.4282 3.39136 8.4282H4.20959Z"
                  fill="#737171" />
                <path
                  d="M16.7374 16.1638C17.3767 15.8131 17.8159 15.1419 17.8159 14.363C17.8159 13.2263 16.8907 12.3018 15.754 12.3018C15.3543 12.3018 14.9839 12.4212 14.6674 12.6189C14.4778 13.3733 14.1794 14.095 13.7891 14.7218C14.8956 14.9298 15.911 15.4337 16.7374 16.1638Z"
                  fill="#737171" />
                <path
                  d="M20.9961 13.5841C20.9961 13.3461 20.8028 13.1534 20.5656 13.1534H19.6811C19.6048 12.904 19.5035 12.6651 19.3833 12.4383L20.0095 11.8122C20.0909 11.7314 20.1359 11.622 20.1359 11.5078C20.1359 11.3936 20.0908 11.2841 20.0095 11.2032L18.9072 10.1006C18.8234 10.0164 18.7127 9.97416 18.6026 9.97416C18.4925 9.97416 18.3824 10.0164 18.2986 10.1006L17.6712 10.7271C17.4447 10.6069 17.2063 10.5063 16.9561 10.4302V9.54566C16.9561 9.30795 16.764 9.11523 16.5263 9.11523H14.9668C14.8623 9.11523 14.7703 9.15713 14.6953 9.21908C14.8266 9.69826 14.8986 10.2178 14.8986 10.7721C14.8986 11.124 14.8711 11.4812 14.8198 11.8365C15.11 11.7295 15.419 11.6623 15.7463 11.6623C17.2363 11.6623 18.4487 12.8744 18.4487 14.3641C18.4487 15.3163 17.9514 16.1508 17.2051 16.6322C17.7481 17.2277 18.1797 17.9343 18.4606 18.726C18.5069 18.7419 18.5551 18.7535 18.6032 18.7535C18.7133 18.7535 18.8235 18.7116 18.9079 18.6274L20.0108 17.5248C20.0915 17.4441 20.1359 17.3346 20.1359 17.2205C20.1359 17.1063 20.0915 16.9969 20.0108 16.9158L19.3834 16.2893C19.5035 16.0629 19.6048 15.8239 19.6812 15.5743H20.5657C20.6795 15.5743 20.7903 15.5293 20.8703 15.4479C20.9511 15.3675 20.9968 15.2578 20.9968 15.1436L20.9961 13.5841Z"
                  fill="#737171" />
                <path
                  d="M17.5843 19.1157C16.9155 17.148 15.1483 15.7946 13.1083 15.6104C12.4252 16.3338 11.5794 16.7927 10.6215 16.7927C9.66446 16.7927 8.81802 16.3338 8.13554 15.6104C6.0943 15.7946 4.32703 17.148 3.65825 19.1161L3.28857 20.2042C3.18282 20.5173 3.23346 20.8624 3.42618 21.131C3.61885 21.3998 3.92915 21.5593 4.25944 21.5593H16.9831C17.314 21.5593 17.6243 21.3998 17.817 21.131C18.009 20.8624 18.0604 20.5173 17.954 20.2042L17.5843 19.1157Z"
                  fill="#F2C046" />
                <path
                  d="M7.30469 10.7709C7.30469 13.2117 8.79046 15.8306 10.6221 15.8306C12.4545 15.8306 13.9402 13.2117 13.9402 10.7709C13.9402 5.71158 7.30469 5.70155 7.30469 10.7709Z"
                  fill="#F2C046" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12.7187 6.56217C12.6943 6.10613 12.2282 6.18371 11.7734 6.18371C12.1094 6.27318 12.4272 6.39766 12.7187 6.56217Z"
                  fill="#737171" />
                <path
                  d="M7.8624 5.41895C6.09699 5.41895 5.28439 7.6535 6.69568 8.77737C7.17678 7.49273 8.13452 6.57032 9.39007 6.20624C9.04661 5.73142 8.49171 5.41895 7.8624 5.41895Z"
                  fill="#F2C046" />
                <path
                  d="M4.20959 8.4282C4.28154 8.65906 4.37475 8.88054 4.48549 9.09037L3.90557 9.67062C3.74984 9.82635 3.74984 10.0791 3.90557 10.2352L4.92776 11.2577C5.00221 11.3321 5.1042 11.374 5.21051 11.374C5.31565 11.374 5.41696 11.3321 5.4927 11.2577L6.07197 10.6775C6.1589 10.7235 6.25526 10.7517 6.34529 10.7913C6.34529 10.7847 6.34465 10.7779 6.34465 10.7713C6.34465 10.2971 6.39911 9.8498 6.49607 9.42976C5.79667 8.97964 5.32999 8.1983 5.32999 7.30622C5.32999 5.91274 6.46352 4.77889 7.85668 4.77889C8.80004 4.77889 9.61453 5.30406 10.0493 6.07134C10.5135 6.01377 10.9495 6.01377 11.4744 6.11295C11.4069 5.90871 11.3274 5.70883 11.2279 5.52147L11.8078 4.94095C11.8835 4.86618 11.9254 4.76451 11.9254 4.6588C11.9254 4.55306 11.8835 4.45142 11.8078 4.37666L10.7862 3.35479C10.7081 3.2766 10.6061 3.23781 10.5041 3.23781C10.4021 3.23781 10.3002 3.2766 10.2226 3.35479L9.64079 3.93531C9.43063 3.82397 9.2098 3.73076 8.97837 3.66038V2.84021C8.97837 2.62002 8.80068 2.44141 8.57985 2.44141H7.13416C6.91458 2.44141 6.73499 2.62002 6.73499 2.84021V3.66034C6.50417 3.73072 6.2833 3.82393 6.07249 3.93527L5.4927 3.3554C5.41447 3.27721 5.31251 3.23841 5.21051 3.23841C5.10855 3.23841 5.00599 3.27721 4.92841 3.35507L3.90557 4.37694C3.83113 4.45203 3.78923 4.55334 3.78923 4.65941C3.78923 4.76543 3.83113 4.86679 3.90557 4.94155L4.48549 5.52175C4.37471 5.73195 4.28154 5.95311 4.21088 6.18393H3.39136C3.17052 6.18393 2.99219 6.36283 2.99219 6.58334V8.02907C2.99219 8.24894 3.17052 8.4282 3.39136 8.4282H4.20959Z"
                  fill="#F2C046" />
                <path
                  d="M16.7374 16.1638C17.3767 15.8131 17.8159 15.1419 17.8159 14.363C17.8159 13.2263 16.8907 12.3018 15.754 12.3018C15.3543 12.3018 14.9839 12.4212 14.6674 12.6189C14.4778 13.3733 14.1794 14.095 13.7891 14.7218C14.8956 14.9298 15.911 15.4337 16.7374 16.1638Z"
                  fill="#F2C046" />
                <path
                  d="M20.9961 13.5841C20.9961 13.3461 20.8028 13.1534 20.5656 13.1534H19.6811C19.6048 12.904 19.5035 12.6651 19.3833 12.4383L20.0095 11.8122C20.0909 11.7314 20.1359 11.622 20.1359 11.5078C20.1359 11.3936 20.0908 11.2841 20.0095 11.2032L18.9072 10.1006C18.8234 10.0164 18.7127 9.97416 18.6026 9.97416C18.4925 9.97416 18.3824 10.0164 18.2986 10.1006L17.6712 10.7271C17.4447 10.6069 17.2063 10.5063 16.9561 10.4302V9.54566C16.9561 9.30795 16.764 9.11523 16.5263 9.11523H14.9668C14.8623 9.11523 14.7703 9.15713 14.6953 9.21908C14.8266 9.69826 14.8986 10.2178 14.8986 10.7721C14.8986 11.124 14.8711 11.4812 14.8198 11.8365C15.11 11.7295 15.419 11.6623 15.7463 11.6623C17.2363 11.6623 18.4487 12.8744 18.4487 14.3641C18.4487 15.3163 17.9514 16.1508 17.2051 16.6322C17.7481 17.2277 18.1797 17.9343 18.4606 18.726C18.5069 18.7419 18.5551 18.7535 18.6032 18.7535C18.7133 18.7535 18.8235 18.7116 18.9079 18.6274L20.0108 17.5248C20.0915 17.4441 20.1359 17.3346 20.1359 17.2205C20.1359 17.1063 20.0915 16.9969 20.0108 16.9158L19.3834 16.2893C19.5035 16.0629 19.6048 15.8239 19.6812 15.5743H20.5657C20.6795 15.5743 20.7903 15.5293 20.8703 15.4479C20.9511 15.3675 20.9968 15.2578 20.9968 15.1436L20.9961 13.5841Z"
                  fill="#F2C046" />
                <path
                  d="M17.5843 19.1157C16.9155 17.148 15.1483 15.7946 13.1083 15.6104C12.4252 16.3338 11.5794 16.7927 10.6215 16.7927C9.66446 16.7927 8.81802 16.3338 8.13554 15.6104C6.0943 15.7946 4.32703 17.148 3.65825 19.1161L3.28857 20.2042C3.18282 20.5173 3.23346 20.8624 3.42618 21.131C3.61885 21.3998 3.92915 21.5593 4.25944 21.5593H16.9831C17.314 21.5593 17.6243 21.3998 17.817 21.131C18.009 20.8624 18.0604 20.5173 17.954 20.2042L17.5843 19.1157Z"
                  fill="#737171" />
                <path
                  d="M7.30469 10.7709C7.30469 13.2117 8.79046 15.8306 10.6221 15.8306C12.4545 15.8306 13.9402 13.2117 13.9402 10.7709C13.9402 5.71158 7.30469 5.70155 7.30469 10.7709Z"
                  fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>
      </div>

      <span class="w-auto bg-slate-100 mx-4 rounded-full xl:my-0 my-0" style="padding: 0.5px 0px"></span>

      <div class="flex relative items-center w-full justify-end flex-col gap-8 h-full">
        <vx-tooltip text="Switch to User" position="right" class="flex flex-col w-full">
          <router-link to="/user/dashboard" :class="activeRoute === 'my-organizations' ? 'sidebar__item__active' : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                <rect width="24" height="24" fill="" />
                <path
                  d="M15.5118 20.9279C15.5118 21.3267 15.2155 21.6562 14.8311 21.7083L14.7242 21.7155H5.79765C3.97765 21.7155 2.49036 20.291 2.38995 18.4961L2.38455 18.3024L2.38455 4.97666L1.62876 5.73209C1.34913 6.01172 0.911561 6.03714 0.603215 5.80835L0.514874 5.73209C0.235245 5.45246 0.209824 5.01488 0.438611 4.70654L0.514874 4.6182L2.61524 2.51783L2.69088 2.45125C2.69421 2.44868 2.69756 2.44613 2.70093 2.44361L2.61524 2.51783C2.65416 2.47892 2.69613 2.44493 2.74038 2.41586C2.76155 2.40204 2.78359 2.38903 2.80628 2.37711C2.81586 2.37203 2.82503 2.36746 2.83427 2.36307C2.8624 2.34968 2.89229 2.3376 2.92302 2.32736C2.93031 2.32499 2.93669 2.32297 2.94308 2.32103C3.015 2.29906 3.0922 2.28714 3.17219 2.28714C3.21251 2.28714 3.25212 2.29017 3.29081 2.29601C3.30295 2.29791 3.31525 2.30007 3.3275 2.30252C3.35376 2.30771 3.37927 2.31419 3.40426 2.32188C3.4165 2.32569 3.42916 2.32993 3.44172 2.33449C3.46619 2.3434 3.48936 2.35317 3.51194 2.36398C3.52413 2.36975 3.53708 2.37637 3.54989 2.38337C3.57511 2.39727 3.59897 2.41208 3.62194 2.42809C3.62797 2.43221 3.63441 2.43683 3.64079 2.44157C3.67568 2.46795 3.7033 2.492 3.72913 2.51783L5.8295 4.6182C6.13709 4.92579 6.13709 5.4245 5.8295 5.73209C5.54987 6.01172 5.1123 6.03714 4.80395 5.80835L4.71561 5.73209L3.95983 4.97561L3.95983 18.3024C3.95983 19.2667 4.70242 20.0575 5.64692 20.1342L5.79765 20.1403H14.7242C15.1592 20.1403 15.5118 20.4929 15.5118 20.9279Z"
                  fill="#FBB603" />
                <path
                  d="M8.4875 3.07455C8.4875 2.6758 8.78381 2.34626 9.16825 2.29411L9.27513 2.28692L18.2016 2.28692C20.0216 2.28692 21.5089 3.71143 21.6093 5.50631L21.6147 5.69999V19.0257L22.3705 18.2702C22.6501 17.9906 23.0877 17.9652 23.396 18.194L23.4843 18.2702C23.764 18.5499 23.7894 18.9874 23.5606 19.2958L23.4843 19.3841L21.384 21.4845L21.3084 21.551C21.305 21.5536 21.3017 21.5562 21.2983 21.5587L21.384 21.4845C21.3451 21.5234 21.3031 21.5574 21.2589 21.5864C21.2377 21.6003 21.2156 21.6133 21.193 21.6252C21.1834 21.6303 21.1742 21.6348 21.165 21.6392C21.1368 21.6526 21.107 21.6647 21.0762 21.6749C21.0689 21.6773 21.0626 21.6793 21.0562 21.6813C20.9842 21.7032 20.907 21.7152 20.8271 21.7152C20.7867 21.7152 20.7471 21.7121 20.7084 21.7063C20.6963 21.7044 20.684 21.7022 20.6717 21.6998C20.6455 21.6946 20.62 21.6881 20.595 21.6804C20.5827 21.6766 20.5701 21.6724 20.5575 21.6678C20.5331 21.6589 20.5099 21.6491 20.4873 21.6383C20.4751 21.6325 20.4622 21.6259 20.4494 21.6189C20.4241 21.605 20.4003 21.5902 20.3773 21.5742C20.3713 21.5701 20.3648 21.5655 20.3585 21.5607C20.3236 21.5343 20.2959 21.5103 20.2701 21.4845L18.1698 19.3841C17.8622 19.0765 17.8622 18.5778 18.1698 18.2702C18.4494 17.9906 18.887 17.9652 19.1953 18.194L19.2836 18.2702L20.0394 19.0267V5.69999C20.0394 4.73574 19.2968 3.94494 18.3523 3.86827L18.2016 3.86218L9.27513 3.86218C8.84014 3.86218 8.4875 3.50955 8.4875 3.07455Z"
                  fill="#FBB603" />
                <path
                  d="M11.9946 10.8824C13.264 10.8824 14.293 9.8534 14.293 8.58406C14.293 7.31472 13.264 6.28572 11.9946 6.28572C10.7253 6.28572 9.69629 7.31472 9.69629 8.58406C9.69629 9.8534 10.7253 10.8824 11.9946 10.8824Z"
                  fill="#FBB603" />
                <path
                  d="M16.5911 15.1918C16.5911 16.6196 16.5911 17.7774 11.9945 17.7774C7.39777 17.7774 7.39777 16.6196 7.39777 15.1918C7.39777 13.764 9.45593 12.6062 11.9945 12.6062C14.533 12.6062 16.5911 13.764 16.5911 15.1918Z"
                  fill="#FBB603" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_864_138)">
                  <path
                    d="M15.5089 20.9279C15.5089 21.3267 15.2126 21.6562 14.8282 21.7083L14.7213 21.7155H5.79472C3.97472 21.7155 2.48743 20.291 2.38702 18.4961L2.38162 18.3024V4.97663L1.62583 5.73206C1.3462 6.01169 0.908631 6.03711 0.600285 5.80832L0.511944 5.73206C0.232315 5.45243 0.206894 5.01485 0.435681 4.70651L0.511944 4.61817L2.61231 2.5178L2.68795 2.45122C2.69128 2.44865 2.69463 2.4461 2.698 2.44358L2.61231 2.5178C2.65123 2.47889 2.6932 2.4449 2.73745 2.41583C2.75862 2.40201 2.78066 2.389 2.80335 2.37708C2.81293 2.372 2.8221 2.36743 2.83134 2.36304C2.85947 2.34965 2.88936 2.33757 2.92009 2.32733C2.92738 2.32496 2.93376 2.32294 2.94015 2.321C3.01207 2.29903 3.08927 2.28711 3.16926 2.28711C3.20958 2.28711 3.24919 2.29014 3.28788 2.29598C3.30002 2.29788 3.31232 2.30004 3.32457 2.30249C3.35083 2.30768 3.37634 2.31416 3.40133 2.32185C3.41357 2.32566 3.42623 2.3299 3.43879 2.33446C3.46326 2.34337 3.48643 2.35314 3.50901 2.36395C3.5212 2.36972 3.53415 2.37634 3.54696 2.38334C3.57218 2.39724 3.59604 2.41205 3.61901 2.42806C3.62504 2.43218 3.63148 2.4368 3.63786 2.44154C3.67275 2.46792 3.70037 2.49197 3.7262 2.5178L5.82657 4.61817C6.13416 4.92576 6.13416 5.42447 5.82657 5.73206C5.54694 6.01169 5.10937 6.03711 4.80102 5.80832L4.71268 5.73206L3.9569 4.97558V18.3024C3.9569 19.2667 4.69949 20.0575 5.64399 20.1342L5.79472 20.1403H14.7213C15.1563 20.1403 15.5089 20.4929 15.5089 20.9279Z"
                    fill="#737171" />
                  <path
                    d="M8.48438 3.07474C8.48438 2.67599 8.78068 2.34645 9.16512 2.2943L9.27201 2.28711H18.1985C20.0185 2.28711 21.5058 3.71162 21.6062 5.5065L21.6116 5.70018V19.0259L22.3674 18.2704C22.647 17.9908 23.0846 17.9654 23.3929 18.1942L23.4812 18.2704C23.7609 18.5501 23.7863 18.9876 23.5575 19.296L23.4812 19.3843L21.3809 21.4847L21.3053 21.5512C21.3019 21.5538 21.2986 21.5564 21.2952 21.5589L21.3809 21.4847C21.342 21.5236 21.3 21.5576 21.2558 21.5866C21.2346 21.6005 21.2125 21.6135 21.1899 21.6254C21.1803 21.6305 21.1711 21.635 21.1619 21.6394C21.1337 21.6528 21.1039 21.6649 21.0731 21.6751C21.0658 21.6775 21.0595 21.6795 21.0531 21.6815C20.9811 21.7034 20.9039 21.7154 20.824 21.7154C20.7836 21.7154 20.744 21.7123 20.7053 21.7065C20.6932 21.7046 20.6809 21.7024 20.6686 21.7C20.6424 21.6948 20.6169 21.6883 20.5919 21.6806C20.5796 21.6768 20.567 21.6726 20.5544 21.668C20.53 21.6591 20.5068 21.6493 20.4842 21.6385C20.472 21.6327 20.4591 21.6261 20.4463 21.6191C20.421 21.6052 20.3972 21.5904 20.3742 21.5744C20.3682 21.5703 20.3617 21.5657 20.3554 21.5609C20.3205 21.5345 20.2928 21.5105 20.267 21.4847L18.1667 19.3843C17.8591 19.0767 17.8591 18.578 18.1667 18.2704C18.4463 17.9908 18.8839 17.9654 19.1922 18.1942L19.2805 18.2704L20.0363 19.0269V5.70018C20.0363 4.73593 19.2937 3.94513 18.3492 3.86846L18.1985 3.86237H9.27201C8.83702 3.86237 8.48438 3.50974 8.48438 3.07474Z"
                    fill="#737171" />
                  <path
                    d="M11.9936 10.8828C13.263 10.8828 14.292 9.85381 14.292 8.58447C14.292 7.31513 13.263 6.28613 11.9936 6.28613C10.7243 6.28613 9.69531 7.31513 9.69531 8.58447C9.69531 9.85381 10.7243 10.8828 11.9936 10.8828Z"
                    fill="#F2C046" />
                  <path
                    d="M16.5918 15.192C16.5918 16.6198 16.5918 17.7776 11.9952 17.7776C7.39844 17.7776 7.39844 16.6198 7.39844 15.192C7.39844 13.7642 9.4566 12.6064 11.9952 12.6064C14.5337 12.6064 16.5918 13.7642 16.5918 15.192Z"
                    fill="#F2C046" />
                </g>
                <defs>
                  <clipPath id="clip0_864_138">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>
      </div>

      <div class="hidden relative items-center w-full justify-center flex-col gap-8">
        <div class="grid place-content-center justify-center grid-flow-col items-center gap-4">
          <div class="flex justify-between items-center p-2 bg-green-400 rounded-lg gap-4 w-fit">
            <img class="w-4" src="@/assets/images/new-sidebar/icon.svg" />
          </div>

          <a class="text-base font-normal text-slate-500 bg-none w-fit rounded-lg toggle">Board Name</a>
        </div>

        <div class="grid place-content-center justify-center grid-flow-col items-center gap-4">
          <div class="flex justify-between items-center p-2 bg-blue-400 rounded-lg gap-4 w-fit">
            <img class="w-4" src="@/assets/images/new-sidebar/icon.svg" />
          </div>

          <a class="text-base font-normal text-slate-500 bg-none w-fit rounded-lg toggle">Board Name</a>
        </div>

        <div class="grid place-content-center justify-center grid-flow-col items-center gap-4">
          <div class="flex justify-between items-center p-2 bg-purple-400 rounded-lg gap-4 w-fit">
            <img class="w-4" src="@/assets/images/new-sidebar/icon.svg" />
          </div>

          <a class="text-base font-normal text-slate-500 bg-none w-fit rounded-lg toggle">Board Name</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "v-nav-menu",
  components: {},
  props: {},
  computed: {
    activeRoute() {
      return this.$route.name.toLowerCase();
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
  },
  created() {
    if (this.isUserLoggedIn) {
      this.$store
        .dispatch("boards/fetchUserBoardData", this.$store.state.auth.user._id)
        .then((res) => {
          if (res.data) {
            this.organizationIds = res.data.boardData.organizationId;
          }
        })
        .catch((err) => {
          throw err;
        });
    }
    this.$store
      .dispatch("boards/fetchUserBoardData", this.$store.state.auth.user._id)
      .then((res) => { })
      .catch((err) => {
        throw err;
      });
    this.$store
      .dispatch("users/fetchUser", this.$store.state.auth.user._id)
      .then((res) => {
        this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
      });
  },
};
</script>

<style lang="scss">
.sidebar__item {
  cursor: pointer;

  .__hover {
    transition: all 0.1s ease-in;
    opacity: 0;
  }
}

.sidebar__item:hover {
  .__hover {
    opacity: 1;
  }
}

.sidebar__item__active {
  cursor: pointer;

  .__hover {
    transition: all 0.1s ease-in;
    opacity: 1;
  }
}

.toggle {
  display: none;
}

.active path {
  stroke: #ffcc00 !important;
}
</style>
